import React from 'react'
import { AssistanceDomestiquePackage } from '../../generated/graphql'
import CoverListItem from '../../components/quotation/coverListItem/CoverListItem'
import { useQuotation } from '../context'

type Props = React.PropsWithChildren & {
  displayOnlyCover?: boolean
}

export const PricingASDProCoversOptions = ({ displayOnlyCover }: Props) => {
  const { quotation } = useQuotation()

  const covers = quotation.covers?.assistanceDomestiqueProfessionnel
  const details = quotation.details?.assistanceDomestiqueProfessionnel

  return (
    <>
      {details?.packageOptionAssistance == AssistanceDomestiquePackage.Basic && (
        <div className="space-y-3">
          <p>Nous incluons 3 garanties essentielles pour protéger au mieux votre logement :</p>

          <CoverListItem label="Electricite" amount={covers?.electricite} />
          <CoverListItem label="Serrurie / Vitrerie" amount={covers?.serrurieVitrerie} />
          <CoverListItem label="Plomberie intérieure/extérieure" amount={covers?.plomberie} />
        </div>
      )}

      {details?.packageOptionAssistance == AssistanceDomestiquePackage.Premium && (
        <div className="space-y-3">
          <p>Nous incluons 4 garanties essentielles pour protéger au mieux votre logement :</p>

          <CoverListItem label="Electricite" amount={covers?.electricite} />
          <CoverListItem label="Serrurie / Vitrerie" amount={covers?.serrurieVitrerie} />
          <CoverListItem label="Plomberie intérieure/extérieure" amount={covers?.plomberie} />
          <CoverListItem label="Chauffage" amount={covers?.chauffage} />
        </div>
      )}
    </>
  )
}
